The URI of the job ad.
